const SCRIPT_SRCS = [
  'assets/js/jquery-3.5.1.min.js',
  'assets/js/bootstrap.min.js',
  'assets/js/plugin.js',
  'assets/js/main.js',
  'assets/js/custom-nav.js',
  'assets/js/custom-lightbox.js',
];

const ensureScript = (src) => {
  const existing = document.querySelector(`script[data-legacy-src="${src}"]`);
  if (existing) return;

  const script = document.createElement('script');
  script.src = src;
  script.async = false;
  script.dataset.legacySrc = src;
  document.body.appendChild(script);
};

export const loadLegacyScripts = () => {
  if (typeof document === 'undefined') return;

  const baseUrl = import.meta.env.BASE_URL || '/';
  SCRIPT_SRCS.forEach((path) => ensureScript(`${baseUrl}${path}`));
};

loadLegacyScripts();
